const firebaseConfig = {
    apiKey: "AIzaSyDbBGzVChEtTaNyTVe0Kjs1LUUMxy0mrx8",
    authDomain: "doctors-portal8.firebaseapp.com",
    databaseURL: "https://doctors-portal8.firebaseio.com",
    projectId: "doctors-portal8",
    storageBucket: "doctors-portal8.appspot.com",
    messagingSenderId: "182407521204",
    appId: "1:182407521204:web:3d3c83173f9cac1eecc8e1"
  };

export default firebaseConfig;